var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.41,7.34l-.74-.75a2.12,2.12,0,0,0-3,0h0L11.88,19.33,7.34,14.87a2.13,2.13,0,0,0-3,0l-.74.75a2.09,2.09,0,0,0,0,3h0l6.83,6.81a2.12,2.12,0,0,0,3,0h0l15-15.07A2.12,2.12,0,0,0,28.41,7.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCheck);
export default __webpack_public_path__ + "static/media/menu-check.36a1da5b.svg";
export { ForwardRef as ReactComponent };